import { Injectable, inject } from '@angular/core'
import { ApplicationRef } from '@angular/core'
import { Router } from '@angular/router'

import { FrameDetectionService } from '../modules/shared/services/frame-detection.service'
import { UrlSynchronizationService } from '../modules/shared/services/url-synchronization.service'
import { AuthService } from './auth.service'
import { UserService } from '../modules/shared/services'

@Injectable({ providedIn: 'root' })
export class AuthBootstrapService {
  private authService = inject(AuthService)
  private router = inject(Router)
  private appRef = inject(ApplicationRef)
  private userService = inject(UserService)
  private frameDetectionService = inject(FrameDetectionService)
  private urlSynchronizationService = inject(UrlSynchronizationService)

  /**
   * Initialization logic to be run at app startup
   * hooked into APP_INITIALIZER
   */
  init(): Promise<void> {
    return new Promise((resolve) => {
      this.authService.authState$.subscribe((authState) => {
        if (!authState.initialized) return

        if (authState.isAuthenticated) {
          this.userService.loadProfile(true).subscribe()
          const storedRedirectPath = this.authService.getLoginRedirectPath(true)
          const isLoginPage = this.router.url === '/login'

          if (storedRedirectPath && isLoginPage) {
            this.router.navigateByUrl(storedRedirectPath).then(() => {
              this.appRef.tick() // force Angular to re-render the app
            })
          }
        }

        if (this.frameDetectionService.isIframe()) {
          this.urlSynchronizationService.initialize()
          this.urlSynchronizationService.listenToRouterEvents()

          window.addEventListener('unload', () => {
            this.urlSynchronizationService.stopListeningForMessages()
          })
        }

        resolve()
      })
    })
  }
}
